import PropTypes from 'prop-types';
import { IconPlay, IconPause } from 'Icons';
import { Button } from 'Elements';

export const PlayPause = ({
	isPlaying,
	className,
	color,
	size,
	fill,
	onPlayPause
}) => {
	const Icon = isPlaying ? IconPause : IconPlay;
	return (
		<Button
			onClick={onPlayPause}
			className={className}
			title={isPlaying ? 'Pause Current' : 'Play Current'}>
			<Icon color={color} fill={fill} size={size} />
		</Button>
	);
};

PlayPause.defaultProps = {
	size: 26,
	color: '#fff',
	fill: '#fff'
};

PlayPause.propTypes = {
	color: PropTypes.string,
	fill: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
